export { SwapSide, ContractMethod } from 'paraswap-core';

export const API_URL = 'https://api.paraswap.io';
